import React from 'react';
import GameScoreContainer from '../../containers/GameScoreContainer/GameScoreContainer';

const GameScorePage: React.FC = () => {
  return <GameScoreContainer />;
};

export default GameScorePage;
